/**
 * User Picture Profile class
 * Fed from the endpoint /user_picture_profiles/metadata
 */
export default class {
  constructor (data) {
    const url = new URL(data.url)
    url.searchParams.set('size', '256x256')

    this.id = ~~data.id
    this.isActive = data.is_active
    this.updatedAt = data.updated_at
    this.pictureType = data.picture_type
    this.url = url.href
  }
}
